export default "__VITE_ASSET__2c2be9f0__"